import { createStore } from "vuex";
import { openModuleNamespaced } from "@/store/lib";
import { StarterCallback } from "@/starter";
import window from "@/store/modules/window";

const store = createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    window: openModuleNamespaced(window),
  },
});

export const initStore: StarterCallback = (app) => {
  app.config.globalProperties.$store = store;
  app.use(store);
};
